const YOUTUBE_ID = /(?:youtu\.be\/|youtube(?:-nocookie)?\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=|shorts\/|live\/))([\w-]{11})/;
export function extractYoutubeId(url) {
    var _ref;
    var _url_match;
    return (_ref = (_url_match = url.match(YOUTUBE_ID)) === null || _url_match === void 0 ? void 0 : _url_match[1]) !== null && _ref !== void 0 ? _ref : null;
}
